import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import translations from '../../shared/Translations';
import './index.css';
import AOS from "aos";
import "aos/dist/aos.css";
import superAdminApis from '../../api/services/admin-pages/superAdmin';
import { toast } from 'react-toastify';
import CommonPagination from '../../components/pagination';

function CustomerCollections() {


    useEffect(() => {
      AOS.init({
        duration: 1000,
        once: false,
        mirror: true,
      });
    }, []);
  
    
  const navigate = useNavigate();

        const [lang, setLang] = useState("en");
     const t = (key) => translations[lang][key] || key;
    
     useEffect(() => {
        const savedLang = localStorage.getItem("lang");
        if (savedLang) setLang(savedLang);
      }, []);

      
  const handleBackCustomer = () => {
    navigate("/dashboard");
  };

const [searchTerm, setSearchTerm] = useState(() => {
  const today = new Date().toISOString().split("T")[0]; 
  return today;
});

const formatForPayload = (date) => {
  if (!date) return "";
  const [year, month, day] = date.split("-");
  return `${year}-${month}-${day}`; 
};


const [collectionDashboardList,setCollectionDashboardList] = useState("")
const [collectionList,setCollectionList] = useState([])

   const [loading ,setLoading] = useState(false)
       const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);

const [pageSizes, setPageSizes] = useState(["5", "10", "15", "25", "50", "75", "100","125","150","200","250","500","1000"]);


  useEffect(() => {
  handleCollectionDasboardList()
  handleColectionList(currentPage)
  }, [currentPage,searchTerm]);
  
  
  const handleCollectionDasboardList = () => {
  
    const apiData = {};
  
    superAdminApis.collectionDashboardListAPI(apiData)
      .then((responseData) => {
        if (responseData?.apiStatus?.code === "200") {
          setCollectionDashboardList(responseData?.result || []);
        } else {
          setCollectionDashboardList([]);
          // toast.error(responseData?.apiStatus?.message || "Failed to fetch data");
        }
      })
      .catch((error) => {
        console.error("Error fetching customer details:", error);
        toast.error("An error occurred while fetching data.");
      });
  };
  





const handleColectionList = (page) => {
  setLoading(true);

  const apiData = {
    pageIndex: page - 1,
    dataLength: recordsPerPage,
searchDate: formatForPayload(searchTerm)
  };

  superAdminApis.customerDetailsList(apiData)
    .then((responseData) => {
      if (responseData?.apiStatus?.code === "200") {
        setLoading(false);
        setCollectionList(responseData?.result?.customerDetails || []);
        setTotalRecords(responseData?.result?.totalRecordCount || 0);
      } else {
        setCollectionList([]);
        setLoading(false);
        // toast.error(responseData?.apiStatus?.message || "Failed to fetch data");
      }
    })
    .catch((error) => {
      setLoading(false);
      console.error("Error fetching customer details:", error);
      toast.error("An error occurred while fetching data.");
    });
};

const totalPages = Math.ceil(totalRecords / recordsPerPage);


  return (
    <div>
        <div className="d-flex justify-content-between align-items-center mt-3 mb-4">

        {/* Left side (Breadcrumb) */}
        <nav aria-label="breadcrumb" className={lang === "ta" ? "fs-tamil" : ""}>
          <ol className="breadcrumb mb-0">
            <li className="breadcrumb-item">
              <a href="#" onClick={handleBackCustomer}>  {t("dashboard")}</a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
             Customer Collections
            </li>
          </ol>
        </nav>



      </div>

<div className='customer-list-container card'>

  <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-2 mb-4">
  
  <h5 className={`heading-with-line mb-2 mb-md-0 aquanew-text-effect ${lang === "ta" ? "fs-tamil" : ""}`}>
          <i className="bi bi-cash-coin text-black me-1"></i> Customer Collections
    <span className="smooth-line"></span>
  </h5>

  <div className="search-container mx-auto mb-2 mb-md-0">
    <input
      type="date"
      className="form-control search-input"
      placeholder="Search customers..."
      value={searchTerm}
       onClick={(e) => {
        const input = e.currentTarget;
        if (typeof input.showPicker === "function") {
          input.showPicker(); 
        } else {
          input.focus(); 
        }
      }}
      onChange={(e) => setSearchTerm(e.target.value)}
    />
  </div>
</div>

<div className='row text-center collection-cards mt-3' data-aos="fade-up">

  {/* Today Collection */}
  <div className='col-md-3 mb-3'>
    <div className='card shadow-sm p-3 border-0'>
      <i className="bi bi-cash-stack fs-2 text-success"></i>
      <h6 className='mt-2'>Today Collection</h6>
      <h5 className='amount-text fw-bold text-success'>{collectionDashboardList?.today_collection_count} - ₹{collectionDashboardList?.today_collection}</h5>
    </div>
  </div>

  {/* This Month Collection */}
  <div className='col-md-3 mb-3'>
    <div className='card shadow-sm p-3 border-0'>
      <i className="bi bi-calendar-check fs-2 text-primary"></i>
      <h6 className='mt-2'>Monthly Collection</h6>
      <h5 className='amount-text fw-bold text-primary'> {collectionDashboardList?.monthly_collection_count || 0}
  {" - ₹"}
  {collectionDashboardList?.monthly_collection || 0}</h5>
    </div>
  </div>

  {/* Pending Dues */}
  <div className='col-md-3 mb-3'>
    <div className='card shadow-sm p-3 border-0'>
      <i className="bi bi-exclamation-circle fs-2 text-danger"></i>
      <h6 className='mt-2'>Pending Dues</h6>
<h5 className='amount-text text-danger'>{collectionDashboardList?.pending_dues||'0'}</h5>
    </div>
  </div>

  {/* Active Loans */}
  <div className='col-md-3 mb-3'>
    <div className='card shadow-sm p-3 border-0'>
      <i className="bi bi-people fs-2 text-warning"></i>
      <h6 className='mt-2'>Active Loans</h6>
      <h5 className='amount-text fw-bold text-warning'>{collectionDashboardList?.active_count||'0'}</h5>
    </div>
  </div>

</div>

<div className="table-section mt-5" data-aos="fade-right">
   <h6 className="mb-3 text-muted fw-bold">🧾 Collection Records</h6>
            <table >
              <thead>
                <tr>
                  <th>Loan ID</th>
                  <th>Customer Name</th>
                  <th>Date</th>
                  <th>Payment Type</th>
                  <th>UPI Number</th>
                  <th>Principal Paid (₹)</th>
                  <th>Interest Paid (₹)</th>
                  <th>Total (₹)</th>
                  <th className="text-center">Status</th>
                  {/* <th>Collected By</th> */}
                </tr>
              </thead>
                <tbody>
  {collectionList.length === 0 ? (
    <tr>
      <td colSpan="9" className="text-center fw-bold py-3">
        No data found
      </td>
    </tr>
  ) : (
    collectionList.map((item, index) => (
      <tr key={index}>
        <td>{item?.loan_id || "-"}</td>
        <td>{item?.name || "-"}</td>
        {/* <td>
          {item.last_payment_date
            ? new Date(item.last_payment_date).toISOString().split("T")[0].split("-").reverse().join("-")
            : "-"
          }
        </td> */}
<td>
  {(() => {
    const dateTime = item.last_payment_date; 
    if (!dateTime) return "-";

    const ist = new Date(dateTime + " UTC").toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });

    const cleaned = ist.replace(",", "").replace(" at", "");
    const [date, time, ampm] = cleaned.split(" ");
    const [d, m, y] = date.split("/");

    return `${d}-${m}-${y} `; 
  })()}
</td>


        <td>{item.pay_method || "-"}</td>
        <td>{item?.upi_number|| "-"}</td>
        <td>{item?.principal_paid || "-"}</td>
        <td>{item?.interest_paid || "-"}</td>
        <td className="fw-bold">
          ₹{(Number(item.principal_paid) || 0) + (Number(item.interest_paid) || 0)}
        </td>
        <td className="text-center align-middle'">
  {item?.paid_status === "Closed" ? (
    <span className="badge bg-danger">Closed</span>   
  ) : (
    <span className="badge bg-success">Active</span> 
  )}
</td>
      </tr>
    ))
  )}
</tbody>
             </table>
 <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap">

  {/* LEFT SIDE */}
  <div className="d-flex align-items-center gap-2">
    <select
      className="form-select form-select-sm"
      style={{ width: "80px" }}
      value={recordsPerPage}
      onChange={(e) => setRecordsPerPage(Number(e.target.value))}
    >
      {pageSizes?.map((size) => (
    <option key={size} value={size}>
      {size}
    </option>
  ))}
    </select>

   <span className={lang === "ta" ? "fs-tamil" : ""}>
  {t("showing")} {(currentPage - 1) * recordsPerPage + 1} -{" "}
  {Math.min(currentPage * recordsPerPage, totalRecords)} {t("of")}{" "}
  {totalRecords}
</span>
  </div>

  {/* RIGHT SIDE */}
  <div>
    <CommonPagination
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={setCurrentPage}
    />
  </div>

</div>

</div>
    
</div>
    </div>
  )
}

export default CustomerCollections
